import {
  DashboardAnnouncement,
  DashboardFeatureGrid,
  DashboardHomeFeed,
  DashboardPageHeader,
  DashboardQuickActions,
  FuelColumn,
  UsersCarsColumn,
} from "@/components/overview/DashboardAnalytics";
import {
  AnalyticsSkeleton,
  FeatureGridSkeleton,
} from "@/components/ui/PageSkeleton";
import { useHomeNetworkData, useUserCount } from "@/lib/queries";

export function HomeAnalytics() {
  const network = useHomeNetworkData();
  const userCount = useUserCount();

  if (network.isLoading) return <AnalyticsSkeleton />;

  if (network.error || !network.data) {
    return (
      <p className="text-sm text-red-600">Failed to load dashboard data. Please refresh.</p>
    );
  }

  const { overview, charts, recentCars } = network.data;
  const users = userCount.data ?? 0;

  return (
    <div className="space-y-10">
      <DashboardAnnouncement />
      <DashboardPageHeader />

      {userCount.isLoading ? (
        <FeatureGridSkeleton />
      ) : (
        <DashboardFeatureGrid overview={overview} userCount={users} />
      )}

      <div className="grid items-start gap-10 lg:grid-cols-2">
        <DashboardHomeFeed recentCars={recentCars} />
        <div>
          <SectionActionsHeader />
          <DashboardQuickActions />
        </div>
      </div>

      <div className="space-y-4">
        <UsersCarsColumn overview={overview} charts={charts} />
        <FuelColumn overview={overview} charts={charts} />
      </div>
    </div>
  );
}

function SectionActionsHeader() {
  return (
    <div className="mb-3">
      <h2 className="text-xl font-bold tracking-[-0.02em] text-foreground">Quick actions</h2>
      <p className="mt-1 text-sm font-medium text-muted">Jump into common platform workflows.</p>
    </div>
  );
}
